import './nuevoStroDark.css'
import { useCallback, useState } from 'react';
import Select from "react-select";
import axios from 'axios';
import MensajesCronologiaDark from './MensajesCronologiaDark';
export default function CronologiaDark({ denuncia, cookies }) {
    const [mensaje, setMensaje] = useState({ obs: null, motivo: null })
    const motivoMensajeInput = [{ label: 'IP', value: 'IP' }, { label: 'INV', value: 'INV' }, { label: 'DOC', value: 'DOC' }, { label: 'ARCH', value: 'ARCH' }, { label: 'ARCH ACP', value: 'ARCH ACP' }, { label: 'ARCH FCP', value: 'ARCH FCP' }, { label: 'TDM', value: 'TDM' }, { label: 'TAT', value: 'TAT' }, { label: 'TR', value: 'TR' }, { label: 'OTROS', value: 'OTROS' }]
    const colourStyles = {
        menuList: styles => ({
            ...styles,
            background: '#232A61'
        }),
        option: (styles, { isFocused, isSelected }) => ({
            ...styles,
            background: isFocused
                ? '#42C3BA'
                : isSelected
                    ? '#42C3BA'
                    : undefined,
            border: isFocused
                ? '#42C3BA 1px solid'
                : isSelected
                    ? '#42C3BA 1px solid'
                    : undefined,
            zIndex: 1
        }),
        menu: base => ({
            ...base,
            zIndex: 100,
        }),
        control: (styles) => ({
            ...styles,
            background: '#232A61',
            color: 'white',
            borderColor: '#232A61',
        }),
        singleValue: (styles) => ({
            ...styles,
            color: 'white',
        }),
    }
    const today = new Date();
    let day = today.getDate();
    let month = today.getMonth() + 1;
    const year = today.getFullYear();
    day = (day < 10) ? '0' + day : day;
    month = (month < 10) ? '0' + month : month;
    const formattedDate = day + '/' + month + '/' + year;
    function getCurrentTime() {
        const now = new Date();
        let hour = now.getHours();
        let minute = now.getMinutes();
        minute = (minute < 10) ? '0' + minute : minute;
        return hour + ':' + minute;
    }
    const currentTime = getCurrentTime();
    const comentarioUpdate = useCallback(async (e) => {
        e.preventDefault()
        await axios.post(`https://back.agsseguros.online/api/cronologia`,
            {
                id: denuncia.id,
                desc: '-',
                obs: mensaje.obs,
                jerarquia: cookies.user.depto === 'cargas' ? 'CRG' : 'DEN',
                motivo: mensaje.motivo,
                autor: cookies.user.usuario,
                fecha: formattedDate,
                hora: currentTime
            }
        ).then((response) => { if (response) { window.location.reload() } })
    }, [mensaje, denuncia, cookies, currentTime, formattedDate]);
    return (
        <div className="pe-4 ps-4 text-white">
            <div className="chatContainer">
                <div className="mensajesContainer my-scrollbar">
                    {denuncia?.cronologia.map((m) => (
                        <MensajesCronologiaDark mensaje={m} user={cookies.user.id} />
                    ))}
                </div>
                <div className="inputContainer">
                    <textarea
                        className="burbujaModuloActualizacionStro1Dark burbujaModuloActualizacionStro1Dark3 ps-3 pt-1"
                        value={mensaje.obs}
                        onChange={(e) =>
                            setMensaje((prevState) => ({
                                ...prevState,
                                obs: e.target.value,
                            }))
                        }
                    />
                    <div className="sendContainer">
                        <div className="sendMessageBtnContainer center">
                            <button
                                className="btnNO text-white"
                                onClick={(e) => comentarioUpdate(e)}
                                disabled={
                                    cookies?.user?.depto === 'emision'
                                        ? true
                                        : mensaje.motivo === null
                                }
                            >
                                <i className="bi bi-send"></i>
                            </button>
                        </div>
                        <div className="sendMessageUserContainer mt-2">
                            <Select
                                styles={colourStyles}
                                options={motivoMensajeInput}
                                className="w-100"
                                placeholder=""
                                onChange={(newValue) =>
                                    setMensaje((prevState) => ({
                                        ...prevState,
                                        motivo: newValue.value,
                                    }))
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}